import React from 'react';
import { arrowImg } from './img/arrow_img.js';
import Icon from '../icon/icon.js';
import Title from '../title/title.js';

const renderArrow = (active, couponType) => {
    if (active) {
        return (React.createElement(Icon, { className: `mbw-coupon-arrow-${couponType}`, dataTestId: "mbw-coupon-arrow" }, arrowImg));
    }
    return null;
};
const Coupon = ({ couponType = "small", active = true, discountText, icon, description, badge }) => {
    const couponStyleByState = active ? "mbw-coupon-active" : "mbw-coupon-inactive";
    let titleByType;
    switch (couponType) {
        case "large":
            titleByType = "heading-h4";
            break;
        case "medium":
            titleByType = "heading-h5";
            break;
        case "small":
            titleByType = "content-medium";
            break;
    }
    const renderCoupon = () => (React.createElement("div", { "data-testid": "mbw-coupon-container", className: `mbw-coupon-container-${couponType} ${couponStyleByState}` },
        badge && React.createElement("div", { "data-testid": "mbw-coupon-badge", className: "mbw-coupon-badge" }, badge),
        React.createElement("div", { "data-testid": "mbw-coupon-content", className: "mbw-coupon-content" },
            icon && React.createElement(Icon, { className: `mbw-coupon-icon-${couponType}`, dataTestId: "mbw-coupon-icon" }, icon),
            React.createElement("div", { className: "mbw-coupon-info-container", "data-testid": "mbw-coupon-info-container" },
                React.createElement("div", { className: `mbw-coupon-info-${couponType}`, "data-testid": "mbw-coupon-info" },
                    React.createElement(Title, { fontStyle: titleByType, bold: true }, discountText),
                    description && React.createElement(Title, { fontStyle: "caption-1" }, description)),
                renderArrow(active, couponType)))));
    return renderCoupon();
};

export { Coupon as default };
//# sourceMappingURL=coupon.js.map
